import { BoletoMensagens } from '../boletos/messages'

export const MensagensSucessoPagamento = {
  boleto: BoletoMensagens.PAGAMENTO_SUCESSO_BOLETO,
  cartao: 'Pagamento com cartão de crédito realizado com sucesso!',
  link: 'Após a geração das propostas será enviado o link de pagamento!'
}
